import { Card } from '@codametrix/ui-components';
import React from 'react';
// svgs
import './styles/index.scss';
import HourGlass from '../../assets/hourGlass.svg';
import BanSign from '../../assets/banSign.svg';
import { BiomeIcon, IconName } from '@codametrix/verdigris';

const ProcessStatus = (props: Accelerate.ProcessStatusProps) => {
  const { benchEditable } = props;

  if (benchEditable.waiting) {
    return (
      <Card className="accelerate-process-status">
        <div className="pre-coding" data-testid="process-status-pre-coding">
          <span className="waiting-icon">
            <img src={HourGlass} />
          </span>
          <span className="text-info">
            Collecting information. Please check back again.
          </span>
        </div>
      </Card>
    );
  } else if (benchEditable.submitted) {
    return (
      <div className="accelerate-process-status">
        <div className="post-coding" data-testid="process-status-post-coding">
          <BiomeIcon
            iconName={IconName.Check_Circle}
            iconClass="status-icon"
            titleText="Case is coded."
          />
          <div className="status-text">This case has been coded.</div>
        </div>{' '}
      </div>
    );
  } else if (benchEditable.cancelled) {
    return (
      <div className="accelerate-process-status">
        <div className="post-coding" data-testid="process-status-post-coding">
          <div className="status-icon">
            <img src={BanSign} style={{ width: '1rem', marginTop: '2px' }} />
          </div>
          <div className="status-text">
            This case is cancelled and will not be sent to billing.
          </div>
        </div>{' '}
      </div>
    );
  } else {
    return (
      <span
        className="empty-process-status"
        data-testid="process-status-empty"
      />
    );
  }
};

export { ProcessStatus };
